export var FilterModalType;
(function (FilterModalType) {
    FilterModalType["List"] = "list";
    FilterModalType["Date"] = "date";
    FilterModalType["Measure"] = "measure";
})(FilterModalType || (FilterModalType = {}));
export var FilterModalVariant;
(function (FilterModalVariant) {
    FilterModalVariant[FilterModalVariant["DEFAULT"] = 0] = "DEFAULT";
    FilterModalVariant[FilterModalVariant["SMALL"] = 1] = "SMALL";
    FilterModalVariant[FilterModalVariant["MEDIUM"] = 2] = "MEDIUM";
})(FilterModalVariant || (FilterModalVariant = {}));
//# sourceMappingURL=filter-modal.interface.js.map